import { Order } from '@/types';
import { bem } from '@/utilities';
import React, { useEffect, useState } from 'react';
import { OrdersList } from './ordersList';

type Props = {
  orders: Order[];
  selectedOrder?: Order;
  setSelectedOrder: (selectedOrder: any) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
};

export const Sidebar: React.FC<Props> = (props) => {
  const { orders, selectedOrder, setSelectedOrder } = props;
  const [searchedOrders, setSearchedOrders] = useState<Order[]>(orders);
  const [searchWord, setSearchWord] = useState('');

  useEffect(() => {
    const fliteredOrders = orders.filter((order) => order.ownedCar.carNumber.includes(searchWord));
    setSearchedOrders(fliteredOrders);
  }, [searchWord, orders]);

  return (
    <div className={bem('schedule-selection', 'sidebar')}>
      <div className={bem('schedule-selection', 'sidebar-search')}>
        <input
          className={bem('schedule-selection', 'sidebar-search__input')}
          placeholder='車両ナンバーで検索'
          onChange={(e) => setSearchWord(e.target.value)}
        />
      </div>
      <div className={bem('schedule-selection', 'sidebar-list')}>
        <OrdersList
          orders={searchedOrders}
          selectedOrder={selectedOrder}
          setSelectedOrder={(selectedOrder: Order) => setSelectedOrder(selectedOrder)}
        />
      </div>
    </div>
  );
};
